import { showCartErrorMessage } from 'features/cart/desktop';

import { cart } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import { UpdateOrderTaxExempt } from '../../api';
import OrderTaxExemptTemplate from '../templates/OrderTaxExemptTemplate';

const OrderTaxExempt = CartBaseItemView.extend({
	JSXTemplate: OrderTaxExemptTemplate,
	ui: {
		taxExemptCheckbox: '#taxExemptCheckbox'
	},
	events: {
		'click @ui.taxExemptCheckbox': 'taxExemptCheckboxClick'
	},
	initialize () {

		this.listenTo(this.model, 'change', this.render);

	},
	taxExemptCheckboxClick () {

		const overrideTax = this.ui.taxExemptCheckbox.prop('checked');

		// api call to update order tax exempt checkbox value
		const request = UpdateOrderTaxExempt(overrideTax)
			.then((response) => {

				if (response.operationSuccess) {

					this.model.update(response);

				} else {

					showCartErrorMessage({ response });

				}

			})
			.catch((error) => {

				// revert to previous checked state
				this.ui.taxExemptCheckbox.prop('checked', this.ui.taxExemptCheckbox.prop('defaultChecked'));

				// show generic error message
				showCartErrorMessage();
				console.error(error);

			});
		$(cart).trigger('indicateLoad', request);

	}
});

export default OrderTaxExempt;
